import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=45907805"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports